
<script>
	
	export default{
		props:{
			'name':{
				type: String,
				required: true,

			},
			'id':{
				type:String,
				default: 'input_file_'+new Date().getTime()
			},
			'height':{
				default: "150px"
			},
			'width':{
				default: "150px"
			},
			'deleble':{
				default:false
			},
			'extensions':{
				type:Array,
				default: function(){
					return ['.jpg','.jpeg','.png','.pdf','.txt','.csv']	
				}
			},
			'value':{
				required:true
			},
			fileURL:{
				type:String,
				default:""
			}
		},
		data(){

			return {
				image: '',
				fileName: '',
				extImages: ['jpg','png','gif','jpeg'],
				extExcel:['csv'],
				extWord:[],
				extPowerPoint:[],
				extVideo:['mp4','rmvb','avi','dvdrip'],
				extAudio:['mp3'],
				extCompact:['zip','rar','targz'],
				localFile: null,
				url:this.fileURL

			}
		},
		methods:{
			onFileChange(e) {
				var files = e.target.files || e.dataTransfer.files;
				if (!files.length)
					return;
				this.createImage(files[0]);
			},
			createImage(file) {
				
				if(!this.validateExtension(file.name)){
					alert("Arquivo Inválido!\nFormatos Aceitos: "+this.extensions.join(','));
					return;
				}
				var image = new Image();
				var reader = new FileReader();
				var vm = this;
				this.fileName = file.name;
				reader.onload = (e) => {
					vm.image = e.target.result;
				};
				reader.readAsDataURL(file);
				
				this.$emit('input',file);
			},
			validateExtension: function(filename){
				console.log(filename);
				return (new RegExp('(' + this.extensions.join('|').replace(/\./g, '\\.') + ')$')).test(filename);
			},
			removeImage: function (e) {
				document.getElementById(this.id).value = "";
				this.fileName = "";
				this.image = '';
				this.url = "";
				this.$emit('input',null);
				this.$emit('remove',this.id);
			},
			downloadFile(){
				
				let url = this.fileURL;

				if(this.localFile !== null){
					url = window.URL.createObjectURL(this.localFile);
				}

				window.open(url,"target_blank");
			}
		},
		watch:{

			value:function(newValue,oldValue){
				this.image=newValue;
				this.localFile = newValue;
			}
		},
		computed:{
			hasFile(){
				if(this.fileName.length > 0 || this.url.length > 0){
					return true;
				}
				return false;
			},
			style(){
				return `
				height: ${this.height}; 
				width: ${this.width};
				`;
			},
			imgPreview(){
				if(this.fileName.length > 0){
					return this.image;
				}
				return this.url;
			},
			isImage(){

				let extURL = this.url.split('.').pop().toLowerCase();
				let extFileInputed = this.fileName.split('.').pop().toLowerCase();


				if(this.extImages.indexOf(extFileInputed) >= 0){
					return true;
				}else if(this.extImages.indexOf(extURL) >= 0 && extFileInputed.length == 0){
					return true;
				}
				return false;
			},
			fontawesomeIconNoImage(){


				let ext = this.url.split('.').pop().toLowerCase();
				let extFileInputed = this.fileName.split('.').pop().toLowerCase();


				if(extFileInputed.length > 0){
					ext = extFileInputed;
				}
				//console.log(ext);
				if(ext === "pdf"){
					return "fa-file-pdf-o";
				}else if(this.extExcel.indexOf(ext) >= 0){
					return "fa-file-excel-o";
				}else if(this.extWord.indexOf(ext) >= 0){
					return "fa-file-word-o";
				}else if(this.extPowerPoint.indexOf(ext) >= 0){
					return "fa-file-powerpoint-o";
				}else if(this.extVideo.indexOf(ext) >= 0){
					return "fa-file-video-o";
				}else if(this.extAudio.indexOf(ext) >= 0){
					return "fa-file-audio-o";
				}else if(this.extCompact.indexOf(ext) >= 0){
					return "fa-file-archive-o";
				}
				
				return "fa-file-o";
			}

		}
	}

</script>

<template>

	<div :style="style" class="content-input-file">



		<span v-show="hasFile || deleble" class="delete" @click="removeImage">X</span>
	</span>
	<input type="file" class="input" :name="name" :id="id" @change="onFileChange">

	<img :id="'img-preview-'+id" v-show="hasFile && isImage" :src="imgPreview" class="img-loaded" >
	<div v-show="hasFile && !isImage"><i class="fa " :class="fontawesomeIconNoImage" style="padding-top: 5px; font-size: 6em;"></i></div>
	<p v-if="!hasFile" style="padding:0px 5px;">

		<i class="fa fa-upload"></i>
		<slot></slot>
	</p>
	<div v-if="hasFile" class="download text-primary" @click="downloadFile"> 
		<i class="fa fa-download"></i>
		<slot></slot>
	</div>

</div>

</template>

<style scoped>
	.input{ 
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid #ff0000;
		opacity: 0.01;
		z-index: 1;
		width: 100%;
		height: 100%;
		cursor: pointer;
	}
	.content-input-file{
		background: rgb(225, 225, 225)  none repeat scroll 0% 0%;
		border-radius: 5px;
		position: relative;
		overflow: hidden;
		text-align: center;
		margin: 0 auto;

	}
	.content-input-file p{
		padding: 0px;
		top: 50%;
		transform: translateY(-50%);
		position: relative;
		margin-top: 0px;
		text-align: center;
	}
	.content-input-file img{

		position: relative;
	}
	.content-input-file .label{
		text-align: center;
		width: 100%;
		background: rgba(255, 255, 255, 0.7);
		z-index: 2;
		position: relative;
	}
	.delete{
		background: #e22828;
		color: #fff;
		cursor: pointer;
		position: absolute;
		z-index: 9;
		border-radius: 50%;
		top: 2px;
		right: 2px;
		height: 30px;
		width: 30px;
		line-height: 31px;
		font-size: 14px;
	}
	.download{
		background: #e22828;
		color: #fff;
		cursor: pointer;
		z-index: 9;
		width: 100%;
		line-height: 14px;
		font-size: 14px;
		position: absolute;
		bottom: 0px;
		padding: 7px 4px;
	}
	.img-loaded{
		display: block;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/util/InputFile.vue